/* eslint-disable @typescript-eslint/ban-ts-comment */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable no-unused-vars */
import styles from './HiddenSectionEmails.module.css';
import { ReactComponent as Close } from '../ico/close.svg';
import { Button } from '../../UI/Button/Button';
import { observer } from 'mobx-react';
import { useStores } from '../../../hooks/useStore';
import { useApi } from '../../../hooks/useApi';
import { Input } from '../../UI/input/input';
import { useEffect, useState } from 'react';
import { HiddenSectionEmailsModel } from '../../../models/hiddenSectionEmails';
import { Checkbox, FormControlLabel } from '@mui/material';

interface PopupProps {
  item: HiddenSectionEmailsModel | null;
  onClose: () => void;
  update: () => void;
}

const HiddenSectionEmailsPopUP: React.FC<PopupProps> = observer(
  ({ item, onClose, update }) => {
    const store = useStores();
    const api = useApi();

    const [email, setEmail] = useState<string>('');
    const [platformIos, setPlatformIos] = useState<boolean>(false);
    const [platformAndroid, setPlatformAndroid] = useState<boolean>(false);

    const [disable, setDisable] = useState<boolean>(true);

    useEffect(() => {
      if (item) {
        setEmail(item.email ?? '');
        setPlatformIos(item.platform_ios ?? false);
        setPlatformAndroid(item.platform_android ?? false);
      }
    }, [item]);

    useEffect(() => {
      if (item) {
        // При редактировании email не обязателен
        setDisable(false);
      } else {
        // При создании email обязателен
        if (email !== '') {
          setDisable(false);
        } else {
          setDisable(true);
        }
      }
    }, [email, item]);

    const handleButtonClick = async () => {
      try {
        store.notificationsStore.showPreloader();

        if (item) {
          // Обновление
          await api.hiddenSectionEmails.update(
            {
              platform_ios: platformIos,
              platform_android: platformAndroid,
            },
            item.id as string,
          );
        } else {
          // Создание
          await api.hiddenSectionEmails.create({
            email: email,
            platform_ios: platformIos,
            platform_android: platformAndroid,
          });
        }

        update();
        onClose();

        store.notificationsStore.setNotifications('Успешно выполнено');
      } catch (e) {
        store.notificationsStore.setError('Ошибка при выполнении');
      } finally {
        store.notificationsStore.hidePreloader();
      }
    };

    const deleteItem = async () => {
      try {
        store.notificationsStore.showPreloader();
        await api.hiddenSectionEmails.delete(item?.id as string);
        store.notificationsStore.setNotifications('Успешно удалено');
        update();
        onClose();
      } catch (e) {
        store.notificationsStore.setError('Ошибка при удалении');
      } finally {
        store.notificationsStore.hidePreloader();
      }
    };

    const [showApproveDelete, setShowApproveDelete] = useState<boolean>(false);

    return (
      <>
        <div
          className={styles.container}
          // onClick={handleOverlayClick}
        >
          <div className={styles.form}>
            <Close className={styles.close} onClick={onClose} />
            <h3>{!item ? 'Добавление' : 'Изменение'} скрытия в app</h3>
            <div className={styles.line} style={{ marginBottom: 20 }} />

            <Input
              style={{ maxWidth: '90%' }}
              value={email}
              placeholder="Email"
              textLabel="Email"
              onChange={(event) => setEmail(event.target.value)}
              disabled={!!item} // Запрещаем редактирование email при обновлении
            />

            <div style={{ maxWidth: '90%', marginTop: 20, marginBottom: 10 }}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={platformIos}
                    onChange={(e) => setPlatformIos(e.target.checked)}
                    color="primary"
                  />
                }
                label="Скрыть для iOS"
              />
            </div>

            <div style={{ maxWidth: '90%', marginBottom: 10 }}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={platformAndroid}
                    onChange={(e) => setPlatformAndroid(e.target.checked)}
                    color="primary"
                  />
                }
                label="Скрыть для Android"
              />
            </div>

            <div className={styles.line} style={{ marginBottom: 10 }} />

            <div
              style={{
                display: 'flex',
                width: '90%',
                justifyContent: 'center',
              }}
            >
              {!showApproveDelete && (
                <Button
                  disabled={disable}
                  onClick={handleButtonClick}
                  style={{ margin: 5, maxWidth: 320, marginBottom: 25 }}
                  appearance="auth"
                >
                  {!item ? 'Создать' : 'Изменить'}
                </Button>
              )}
              {item && !showApproveDelete && (
                <Button
                  onClick={() => setShowApproveDelete(true)}
                  style={{ margin: 5, maxWidth: 320, marginBottom: 25 }}
                  appearance="link"
                >
                  Удалить
                </Button>
              )}

              {showApproveDelete && (
                <div
                  style={{
                    display: 'flex',
                    width: '90%',
                    justifyContent: 'center',
                    flexDirection: 'column',
                    alignItems: 'center',
                  }}
                >
                  <p style={{ marginBottom: 10 }}>Точно хотите удалить?</p>
                  <div
                    style={{
                      display: 'flex',
                      width: '90%',
                      justifyContent: 'center',
                    }}
                  >
                    <Button
                      disabled={disable}
                      onClick={deleteItem}
                      style={{ margin: 5, maxWidth: 320, marginBottom: 25 }}
                      appearance="link"
                    >
                      Удалить
                    </Button>
                    <Button
                      disabled={disable}
                      onClick={() => setShowApproveDelete(false)}
                      style={{ margin: 5, maxWidth: 320, marginBottom: 25 }}
                      appearance="auth"
                    >
                      Отмена
                    </Button>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </>
    );
  },
);

export default HiddenSectionEmailsPopUP;
